import { produce } from 'immer'
import { IssuerIntegratorListResponse } from 'src/models/issuerIntegrator.models'
import {
  GET_ISSUER_SUCCESS,
  GET_ISSUERS_SUCCESS,
  GetIssuersSuccessAction,
  GetIssuerSuccessAction,
} from 'src/redux/actions/data/issuerIntegrators.actions'

export interface IssuerIntegratorsState {
  listResponses: Record<string, IssuerIntegratorListResponse>
  order: string[]
}

export const initialState: IssuerIntegratorsState = {
  listResponses: {},
  order: [],
}

export type Actions = GetIssuersSuccessAction | GetIssuerSuccessAction

const IssuersReducer = (
  state: IssuerIntegratorsState = initialState,
  action: Actions,
): IssuerIntegratorsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_ISSUERS_SUCCESS: {
        draft.listResponses = action.payload.issuers.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          {},
        )
        draft.order = action.payload.issuers.map((group) => group.id)
        return draft
      }

      case GET_ISSUER_SUCCESS: {
        draft.listResponses = {
          ...draft.listResponses,
          [action.payload.id]: action.payload,
        }
      }
    }
  })
}

export default IssuersReducer
